import { SUPPLIER_QUESTIONNAIRE_TYPES } from "../../../../../utils";
import moment from "moment";

export function mapServerDataToFormData(data, consumptionBasedEnabled) {
  return {
    id: data?.id ?? "",
    description: data?.description ?? "",
    supplier: data?.supplierId ?? "",
    questionnaireType: data?.questionnaireType ?? !consumptionBasedEnabled ?
      SUPPLIER_QUESTIONNAIRE_TYPES.EMISSION_BASED : "",
    assignee: data?.assigneeId,
    inviteeEmail: data?.inviteeEmail,
    year: data?.year ?? "",
    quarter: data?.quarter ?? "",
    endDate: data !== null && typeof data !== "undefined" &&
      data.originalEndDate !== null && typeof data.originalEndDate !== "undefined" ?
      new Date(data.originalEndDate) : ""
  };
}

export function mapFormDataToServerData(data, isEdit) {
  const mappedData = {
    description: data.description,
    supplier: {
      id: data.supplier
    },
    period: {
      year: data.year,
      quarter: data.quarter
    }
  };
  mappedData["assigneeId"] = data.assignee;
  if (!isEdit) {
    mappedData["questionnaireType"] = data.questionnaireType;
  }
  if (data.endDate !== null && data.endDate !== "") {
    mappedData.endDate = moment(data.endDate).format("YYYY-MM-DD");
  }

  return mappedData;
}